export default __webpack_public_path__ + "static/media/45738-1000x830-1712921593006.6ba09723.jpg";